import {
  useMediaQuery,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  colors,
} from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader, IconAlternate } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

// Custom styles
const useStyles = makeStyles(theme => ({
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  shape: {
    background: theme.palette.alternate.main,
    borderBottomRightRadius: '100%',
  },
  listItemAvatar: {
    marginRight: theme.spacing(2),
  },
  coverImage: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

export function About(props) {
  const { className, section, image, title, subtitle, features = [], refElem, ...rest } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  const { url: imgSrc, alt: imgAlt } = image || {};

  return (
    <div className={classes.shape}>
      <SectionDynamic type={section} className={classes.sectionNoPaddingTop}>
        <div className={className} ref={refElem} {...rest}>
          <Grid container spacing={4} direction={isMd ? 'row' : 'column-reverse'}>
            <Grid item xs={12} md={6} data-aos="fade-up">
              <SectionHeader title={title} subtitle={subtitle} align="left" disableGutter />
              <List disablePadding>
                {features.map((feature, index) => (
                  <ListItem
                    disableGutters
                    key={feature.title || index.toString()}
                    data-aos="fade-up">
                    <ListItemAvatar className={classes.listItemAvatar}>
                      <IconAlternate
                        size="small"
                        fontIconClass={feature.icon}
                        color={colors.blue}
                      />
                    </ListItemAvatar>
                    <ListItemText primary={feature.title} secondary={feature.subtitle} />
                  </ListItem>
                ))}
              </List>
            </Grid>
            <Grid
              item
              container
              justifyContent="center"
              alignItems="center"
              xs={12}
              md={6}
              data-aos="fade-up">
              {!!imgSrc && (
                <Image src={imgSrc} alt={imgAlt || 'Eskolare'} className={classes.coverImage} />
              )}
            </Grid>
          </Grid>
        </div>
      </SectionDynamic>
    </div>
  );
}

About.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  image: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  features: PropTypes.array,
  refElem: PropTypes.any,
};

export default About;
